/* pages-forms.js
 * Owner: pages agent. Enhances the two enquiry forms (trade and installers).
 * Loaded with defer from sections/lg-page-trade.liquid and
 * sections/lg-page-installers.liquid. Vanilla ES2020, no libraries.
 *
 * The forms work without this file: they are Shopify contact forms that post
 * and reload, and the confirmation or error is printed by Liquid. This file only
 * adds three things:
 *
 *   1. Focus. After a reload the confirmation (or the error) takes focus, so a
 *      screen reader announces it and the page is not left at the top.
 *   2. Honest state when the page holds more than one Shopify form. The footer
 *      email capture is also a Shopify form, and Shopify can mark every form on
 *      the page as posted. Shopify puts the id of the form that was posted in
 *      the URL hash (the form action ends in #<form id>), so when the hash names
 *      a different form, this form goes back to showing its fields and hides
 *      any confirmation or error that was not about it.
 *   3. Double submit protection. On submit the button is disabled and reads
 *      "Sending", the same wording as the Next.js form. A page restored from the
 *      back/forward cache gets the button back.
 *
 * Markup contract (data attributes, no classes):
 *   form[data-lg-enquiry]        the form
 *   [data-lg-enquiry-done]       confirmation panel (tabindex -1, role status)
 *   [data-lg-enquiry-fields]     wrapper around the fields
 *   [data-lg-enquiry-error]      error paragraph (tabindex -1, role alert)
 *   [data-lg-enquiry-submit]     submit button; data-idle-label holds its text
 */
(function () {
  "use strict";

  var SENDING = "Sending";

  function init() {
    var forms = Array.prototype.slice.call(
      document.querySelectorAll("form[data-lg-enquiry]")
    );
    if (!forms.length) return;
    var hash = window.location.hash ? window.location.hash.slice(1) : "";

    forms.forEach(function (form) {
      var done = form.querySelector("[data-lg-enquiry-done]");
      var fields = form.querySelector("[data-lg-enquiry-fields]");
      var error = form.querySelector("[data-lg-enquiry-error]");
      var button = form.querySelector("[data-lg-enquiry-submit]");
      var idleLabel = button ? button.getAttribute("data-idle-label") || button.textContent : "";

      var posted = !!(done && !done.hidden);
      var failed = !!(error && !error.hidden);

      // A different form on the page was the one that posted: show this one normally.
      if ((posted || failed) && hash && hash !== form.id) {
        if (done) done.hidden = true;
        if (error) error.hidden = true;
        if (fields) fields.hidden = false;
        posted = false;
        failed = false;
      }

      if (posted && done) {
        done.focus();
      } else if (failed && error) {
        error.focus();
      }

      form.addEventListener("submit", function () {
        if (!button) return;
        button.disabled = true;
        button.textContent = SENDING;
      });

      window.addEventListener("pageshow", function (event) {
        if (event.persisted && button) {
          button.disabled = false;
          button.textContent = idleLabel;
        }
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
